module.exports = __webpack_public_path__ + "static/img/part3.e9aacff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/part3.png
// module id = kEHn
// module chunks = 1